import { render, staticRenderFns } from "./NotificationResult-Third.vue?vue&type=template&id=57d5bb40&scoped=true"
import script from "./NotificationResult-Third.vue?vue&type=script&lang=js"
export * from "./NotificationResult-Third.vue?vue&type=script&lang=js"
import style0 from "./NotificationResult-Third.vue?vue&type=style&index=0&id=57d5bb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5bb40",
  null
  
)

export default component.exports